import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { translate } from 'core/utils';

function YesNoViewTemplate({ message, disabled, onConfirm, onCancel, yesLabel, noLabel, t }) {
	if (!yesLabel) yesLabel = t('YES');
	if (!noLabel) noLabel = t('NO');
	return (
		<section className="ReactModal__form">
			<div className="ReactModal__header">
				<p className="spc--bottom--sml">{translate(message)}</p>
			</div>
			<div className="ReactModal__footer">
				<button className="btn btn--med btn--primary spc--right--sml spc--bottom--sml" disabled={disabled} onClick={onConfirm} data-cy="yes-option-button">
					{t(yesLabel)}
				</button>
				<button className="btn btn--med btn--ghost spc--bottom--sml" disabled={disabled} onClick={onCancel} data-cy="no-option-button">
					{t(noLabel)}
				</button>
			</div>
		</section>
	);
}

export default defaultTemplate(YesNoViewTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/dialog/YesNoViewTemplate.jsx